import React from "react";
import ChartLegendItem from "./ChartLegendItem";

function ChartLegend(props) {
  const { graphData } = props

  return (
    <ul className="pl-0">
      {
        graphData.map((legendItem) =>
          <ChartLegendItem label={ legendItem.label }
                           name={ legendItem.name }
                           color={ legendItem.color }
                           key={ legendItem.name }
          />
        )
      }
    </ul>
  )
}

export default ChartLegend
